import React from 'react';
import DefaultLayout from '../../../layouts/default';
// Import local page components from the folder directory structure
import PatCheckHeader from './components/PatCheckHeader';
import PatSummaryDashboardRow from './components/PatSummaryDashboardRow';
import PatFormChecklist from './components/PatFormChecklist';

function PATMonthlyCheckPage() {
  return (
    <DefaultLayout>
      <div className="w-full bg-slate-50/50 min-h-screen p-4 md:p-6 space-y-6 font-sans antialiased selection:bg-blue-500/10">
        
        <section className="w-full">
          <PatCheckHeader />
        </section>

        <section className="w-full">
          <PatSummaryDashboardRow />
        </section>

        <main className="w-full">
          <PatFormChecklist />
        </main>

      </div>
    </DefaultLayout>
  );
}

export default PATMonthlyCheckPage;
